import { jsx as _jsx } from "react/jsx-runtime";
import { c } from 'ttag';
const ListItemConflictIndicator = ({ item }) => {
    return item.conflictOf ? (_jsx("div", { className: "mt-0.5 flex flex-wrap items-center", children: _jsx("div", { className: 'mr-1 mt-2 rounded bg-danger px-1.5 py-1 text-danger-contrast', children: _jsx("div", { className: "text-center text-xs font-bold", children: c('B3.Notes.NoteActions.Label').t `Conflicted Copy` }) }) })) : null;
};
export default ListItemConflictIndicator;
